var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 12,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "no-flag_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 17,
  height: 13
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.4.3h16v12H.4z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#no-flag_svg__a)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.4.3v12h16V.3H.4z",
  fill: "#E31D1C"
})), /*#__PURE__*/React.createElement("mask", {
  id: "no-flag_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 17,
  height: 13
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.4.3v12h16V.3H.4z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#no-flag_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.4-.2h-.5v5h-5v3h5v5h3v-5h9v-3h-9v-5H5.4z",
  fill: "#2E42A5",
  stroke: "#F7FCFF"
})))));
export default SvgNoFlag;